import React from 'react';

import PurlForm from '../PurlForm';

const PurlCreateForm = (props) => <PurlForm {...props} isEditMode={false} />;

export default PurlCreateForm;
